import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {post} from './api.js'
import i18n from "./i18n" // 多語言
import mmpublic from '@/views/Public/Index.vue';
post('/api/main/nav', {}).then((res) => {
	const routes = [{
		path: "/",
		component: mmpublic,
		children: [{
			path: "/",
			component: () => import("@/views/Home/Index.vue"),
		}],
	}];
	let addroutes=[];
	res.map((v)=>{
		let nav = [];
		nav.path = v.path;
		nav.name = v.name;
		nav.component = mmpublic;
		nav.ico = v.ico;
		nav.isnav = v.isnav;
		nav.id = v.id;
		nav.children=[];
		v.sub.map((sub)=>{
			let children =[];
			children.id = sub.id;
			children.path = sub.path;
			children.name = sub.path;
			children.meta = {
				title:sub.name
			};
			children.component = resolve =>require(['@/views/'+sub.component], resolve);
			children.isnav = sub.isnav;
			nav.children.push(children);
		})
		addroutes.push(nav);
	})

	let newroutes = routes.concat(addroutes);
	router.options.routes = newroutes;
	router.addRoutes(addroutes);
}).catch((err) => {
	console.log(err)
}).then(()=>{
	new Vue({
		router,
		i18n,
		render: h => h(App)
	}).$mount('#app')
})